export interface ApiGetPatentTemplateResponse {
    EPONEW: string;
    USA: string;
    USB: string;
    UST: string;
    DE: string;
    EM: string;
    NO: string;
    CN: string;
    CAA: string;
    CAB: string;
    CAD: string;
    AU: string;
    WO: string;
    INPADOC: string;
}

export const GetPatentTemplate = Symbol.for('GetPatentTemplate');

export interface GetPatentTemplate {
    getPatentTemplate(): Promise<ApiGetPatentTemplateResponse>;
}
